import {
  HttpErrorResponse,
  HttpResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { NotifactionService } from '../services/notification.service';
import {
  CUSTOM_SUCCESS_MESSAGE,
  SHOW_ERROR_TOAST,
  SHOW_SUCCESS_TOAST
} from '../context/http-context-token';
import { ApiResponse } from '../models/api.model';

export const httpToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(NotifactionService);

  const showSuccess = req.context.get(SHOW_SUCCESS_TOAST);
  const showError = req.context.get(SHOW_ERROR_TOAST);
  const customMessage = req.context.get(CUSTOM_SUCCESS_MESSAGE);

  return next(req).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse && showSuccess) {
          const message =
            customMessage ||
            (event.body as ApiResponse<any>).message ||
            'Operation successful';

          toast.success("Success", message, "Success");
        }
      },
      error: (error: HttpErrorResponse) => {
        if (!showError) return;

        const message =
          error.error?.message ||
          error.message ||
          'Something went wrong';

        toast.error("Error", message, error.status?.toString());
      }
    })
  );
};